import Vue from 'vue'
import i18n from './i18n'

// import Cookies from 'js-cookie'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';

import App from './App.vue'

import router from './router'
import store from './store'
import '@/assets/styles/animations.scss'
import '@/assets/styles/quick.scss'

import { getDicts } from "@/api/dict/data";

import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
// import '@/utils/amfe-flexible'
import 'swiper/css/swiper.css'
// 字典数据组件
import DictData from '@/components/DictData'
import breadcrumb from "@/components/breadcrumb";
Vue.component('breadcrumb', breadcrumb);
import animatedSection from "@/components/animatedSection";
Vue.component('animatedSection', animatedSection)
import LazyComponent from '@/components/lazyComponent.vue';
// 全局注册
Vue.component('LazyComponent', LazyComponent);

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('@/assets/images/error.png'),
  loading: require('@/assets/images/loading.gif'),
  attempt: 1,
})
// 引入滚动动画
import VueAnimateOnScroll from '@/utils/animatedScroll';
Vue.use(VueAnimateOnScroll)
// Vue.directive('animate-onscroll', VueAnimateOnScroll)



Vue.use(Element, {
  i18n:(ket, value)=>i18n.t(ket,value),
  // size: Cookies.get('size') || 'medium' // set element-ui default size
})
Vue.prototype.getDicts = getDicts
Vue.use(VideoPlayer);
DictData.install()
Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
